<template>
  <el-dialog
    :title="$t('Loginsecondaryauthentication')"
    :visible.sync="addDialogVisible"
    width="40%"
    center
    :close-on-click-modal="false"
    @close="dialogCloseFun"
  >
    <el-form
      ref="ruleForm"
      :model="form"
      label-width="160px"
      :rules="rules"
    >
      <el-radio-group
        v-model="form.type"
        @change="onRadioChange"
      >
        <el-radio label="phone">{{$t('phone')}}</el-radio>
        <el-radio label="email">{{$t('emali')}}</el-radio>
      </el-radio-group>

      <el-row v-if="form.type === 'phone'">
        <el-col :span="24">
          <el-form-item
            :label="$t(`phone`)+'：'"
            prop="phoneNumber"
          >
            <el-select
              :placeholder="$t(`areacode`)+'：'"
              v-model="zonevalue"
              filterable
              style="width:30%;margin-right:10px"
            >
              <el-option
                v-for="country in countryCode"
                :key="country.code"
                :label="country.cn+'-'+country.en"
                :value="country.zone"
              ></el-option>
            </el-select>

            <el-input
              v-model="form.phoneNumber"
              :disabled="phonedisabled"
              style="width:40%;margin-right:10px"
            ></el-input>
            <!-- <el-button type="primary" @click="editPhoneNumber">{{$t("Otherphonenumber")}}</el-button>  -->
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item
            :label="$t(`verificationcode`)+'：'"
            prop="code"
          >
            <el-input
              style="width:30%;margin-right:10px"
              v-model="form.code"
            ></el-input>
            <el-button
              type="primary"
              @click="startCountdown"
              :disabled="countdown > 0"
            > {{ countdown > 0? `${$t('regain')}(${countdown}s)` : `${$t('getcode')}` }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="form.type === 'email'">
        <el-col :span="24">
          <el-form-item
            :label="$t(`mail`)+'：'"
            prop="email"
          >
            <el-input
              v-model="form.email"
              :disabled="emaildisabled"
              style="width:60%;margin-right:10px"
            ></el-input>
            <!-- <el-button type="primary" @click="editEmailNumber">{{$t(`Useanotheremailaddress`)}}</el-button>  -->
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$t(`verificationcode`)+'：'"
            prop="emailCode"
          >
            <el-input
              style="width:30%;margin-right:10px"
              v-model="form.emailCode"
            ></el-input>
            <el-button
              type="primary"
              @click="startEmailCountdown"
              :disabled="emailCountdown > 0"
            > {{ emailCountdown > 0? `${$t('regain')}(${emailCountdown}s)` : `${$t('getcode')}` }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >{{$t("confirm")}}</el-button>
        <el-button @click="resetForm('ruleForm')">{{$t("cancel")}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>

import { Api_login, checkTime } from '@/api/api'
import { validatorPhone, validatorEmail } from "@/util/validateRules.js";
import { isMobile, isEmail } from "@/util/validate.js";
export default {

  data() {
    return {
      zonevalue: '',
      //国际手机号分区
      countryCode: [
        {
          'en': 'United Arab Emirates',
          'cn': '阿拉伯联合酋长国',
          'code': 'AE',
          'zone': '971',
        },
        {
          'en': 'Afghanistan',
          'cn': '阿富汗',
          'code': 'AF',
          'zone': '93',
        }, {
          'en': 'Albania',
          'cn': '阿尔巴尼亚',
          'code': 'AL',
          'zone': '355',
        }, {
          'en': 'Algeria',
          'cn': '阿尔及利亚',
          'code': 'DZ',
          'zone': '213',
        }, {
          'en': 'American Samoa',
          'cn': '美属萨摩亚',
          'code': 'AS',
          'zone': '1684',
        }, {
          'en': 'Andorra',
          'cn': '安道尔',
          'code': 'AD',
          'zone': '376',
        }, {
          'en': 'Angola',
          'cn': '安哥拉',
          'code': 'AO',
          'zone': '244',
        }, {
          'en': 'Anguilla',
          'cn': '安圭拉',
          'code': 'AI',
          'zone': '1264',
        }, {
          'en': 'Antigua and Barbuda',
          'cn': '安提瓜和巴布达',
          'code': 'AG',
          'zone': '1268',
        }, {
          'en': 'Argentina',
          'cn': '阿根廷',
          'code': 'AR',
          'zone': '54',
        }, {
          'en': 'Armenia',
          'cn': '亚美尼亚',
          'code': 'AM',
          'zone': '374',
        }, {
          'en': 'Aruba',
          'cn': '阿鲁巴',
          'code': 'AW',
          'zone': '297',
        }, {
          'en': 'Australia',
          'cn': '澳大利亚',
          'code': 'AU',
          'zone': '61',
        }, {
          'en': 'Austria',
          'cn': '奥地利',
          'code': 'AT',
          'zone': '43',
        }, {
          'en': 'Azerbaijan',
          'cn': '阿塞拜疆',
          'code': 'AZ',
          'zone': '994',
        }, {
          'en': 'Bahamas',
          'cn': '巴哈马',
          'code': 'BS',
          'zone': '1242',
        }, {
          'en': 'Bahrain',
          'cn': '巴林',
          'code': 'BH',
          'zone': '973',
        }, {
          'en': 'Bangladesh',
          'cn': '孟加拉国',
          'code': 'BD',
          'zone': '880',
        }, {
          'en': 'Barbados',
          'cn': '巴巴多斯',
          'code': 'BB',
          'zone': '1246',
        }, {
          'en': 'Belarus',
          'cn': '白俄罗斯',
          'code': 'BY',
          'zone': '375',
        }, {
          'en': 'Belgium',
          'cn': '比利时',
          'code': 'BE',
          'zone': '32',
        }, {
          'en': 'Belize',
          'cn': '伯利兹',
          'code': 'BZ',
          'zone': '501',
        }, {
          'en': 'Benin',
          'cn': '贝宁',
          'code': 'BJ',
          'zone': '229',
        }, {
          'en': 'Bermuda',
          'cn': '百慕大群岛',
          'code': 'BM',
          'zone': '1441',
        }, {
          'en': 'Bhutan',
          'cn': '不丹',
          'code': 'BT',
          'zone': '975',
        }, {
          'en': 'Bolivia',
          'cn': '玻利维亚',
          'code': 'BO',
          'zone': '591',
        }, {
          'en': 'BiH',
          'cn': '波斯尼亚和黑塞哥维那',
          'code': 'BA',
          'zone': '387',
        }, {
          'en': 'Botswana',
          'cn': '博茨瓦纳',
          'code': 'BW',
          'zone': '267',
        }, {
          'en': 'Brazil',
          'cn': '巴西',
          'code': 'BR',
          'zone': '55',
        }, {
          'en': 'Brunei',
          'cn': '文莱',
          'code': 'BN',
          'zone': '673',
        }, {
          'en': 'Bulgaria',
          'cn': '保加利亚',
          'code': 'BG',
          'zone': '359',
        }, {
          'en': 'Burkina Faso',
          'cn': '布基纳法索',
          'code': 'BF',
          'zone': '226',
        }, {
          'en': 'Burundi',
          'cn': '布隆迪',
          'code': 'BI',
          'zone': '257',
        }, {
          'en': 'Cambodia',
          'cn': '柬埔寨',
          'code': 'KH',
          'zone': '855',
        }, {
          'en': 'Cameroon',
          'cn': '喀麦隆',
          'code': 'CM',
          'zone': '237',
        }, {
          'en': 'Canada',
          'cn': '加拿大',
          'code': 'CA',
          'zone': '1',
        }, {
          'en': 'Cape Verde',
          'cn': '开普',
          'code': 'CV',
          'zone': '238',
        }, {
          'en': 'Cayman Islands',
          'cn': '开曼群岛',
          'code': 'KY',
          'zone': '1345',
        }, {
          'en': 'Central African Republic',
          'cn': '中非共和国',
          'code': 'CF',
          'zone': '236',
        }, {
          'en': 'Chad',
          'cn': '乍得',
          'code': 'TD',
          'zone': '235',
        }, {
          'en': 'Chile',
          'cn': '智利',
          'code': 'CL',
          'zone': '56',
        }, {
          'en': 'Colombia',
          'cn': '哥伦比亚',
          'code': 'CO',
          'zone': '57',
        }, {
          'en': 'Comoros',
          'cn': '科摩罗',
          'code': 'KM',
          'zone': '269',
        }, {
          'en': 'Cook Islands',
          'cn': '库克群岛',
          'code': 'CK',
          'zone': '682',
        }, {
          'en': 'Costa Rica',
          'cn': '哥斯达黎加',
          'code': 'CR',
          'zone': '506',
        }, {
          'en': 'Croatia',
          'cn': '克罗地亚',
          'code': 'HR',
          'zone': '385',
        }, {
          'en': 'Cuba',
          'cn': '古巴',
          'code': 'CU',
          'zone': '53',
        }, {
          'en': 'Curacao',
          'cn': '库拉索',
          'code': 'CW',
          'zone': '599',
        }, {
          'en': 'Cyprus',
          'cn': '塞浦路斯',
          'code': 'CY',
          'zone': '357',
        }, {
          'en': 'Czech',
          'cn': '捷克',
          'code': 'CZ',
          'zone': '420',
        }, {
          'en': 'DRC',
          'cn': '刚果民主共和国',
          'code': 'CD',
          'zone': '243',
        }, {
          'en': 'Denmark',
          'cn': '丹麦',
          'code': 'DK',
          'zone': '45',
        }, {
          'en': 'Djibouti',
          'cn': '吉布提',
          'code': 'DJ',
          'zone': '253',
        }, {
          'en': 'Dominica',
          'cn': '多米尼加',
          'code': 'DM',
          'zone': '1767',
        }, {
          'en': 'Dominican Republic',
          'cn': '多米尼加共和国',
          'code': 'DO',
          'zone': '1809',
        }, {
          'en': 'Ecuador',
          'cn': '厄瓜多尔',
          'code': 'EC',
          'zone': '593',
        }, {
          'en': 'Egypt',
          'cn': '埃及',
          'code': 'EG',
          'zone': '20',
        }, {
          'en': 'El Salvador',
          'cn': '萨尔瓦多',
          'code': 'SV',
          'zone': '503',
        }, {
          'en': 'Equatorial Guinea',
          'cn': '赤道几内亚',
          'code': 'GQ',
          'zone': '240',
        }, {
          'en': 'Eritrea',
          'cn': '厄立特里亚',
          'code': 'ER',
          'zone': '291',
        }, {
          'en': 'Estonia',
          'cn': '爱沙尼亚',
          'code': 'EE',
          'zone': '372',
        }, {
          'en': 'Ethiopia',
          'cn': '埃塞俄比亚',
          'code': 'ET',
          'zone': '251',
        }, {
          'en': 'Faroe Islands',
          'cn': '法罗群岛',
          'code': 'FO',
          'zone': '298',
        }, {
          'en': 'Fiji',
          'cn': '斐济',
          'code': 'FJ',
          'zone': '679',
        }, {
          'en': 'Finland',
          'cn': '芬兰',
          'code': 'FI',
          'zone': '358',
        }, {
          'en': 'France',
          'cn': '法国',
          'code': 'FR',
          'zone': '33',
        }, {
          'en': 'French Guiana',
          'cn': '法属圭亚那',
          'code': 'GF',
          'zone': '594',
        }, {
          'en': 'French Polynesia',
          'cn': '法属波利尼西亚',
          'code': 'PF',
          'zone': '689',
        }, {
          'en': 'Gabon',
          'cn': '加蓬',
          'code': 'GA',
          'zone': '241',
        }, {
          'en': 'Gambia',
          'cn': '冈比亚',
          'code': 'GM',
          'zone': '220',
        }, {
          'en': 'Georgia',
          'cn': '格鲁吉亚',
          'code': 'GE',
          'zone': '995',
        }, {
          'en': 'Germany',
          'cn': '德国',
          'code': 'DE',
          'zone': '49',
        }, {
          'en': 'Ghana',
          'cn': '加纳',
          'code': 'GH',
          'zone': '233',
        }, {
          'en': 'Gibraltar',
          'cn': '直布罗陀',
          'code': 'GI',
          'zone': '350',
        }, {
          'en': 'Greece',
          'cn': '希腊',
          'code': 'GR',
          'zone': '30',
        }, {
          'en': 'Greenland',
          'cn': '格陵兰岛',
          'code': 'GL',
          'zone': '299',
        }, {
          'en': 'Grenada',
          'cn': '格林纳达',
          'code': 'GD',
          'zone': '1473',
        }, {
          'en': 'Guadeloupe',
          'cn': '瓜德罗普岛',
          'code': 'GP',
          'zone': '590',
        }, {
          'en': 'Guam',
          'cn': '关岛',
          'code': 'GU',
          'zone': '1671',
        }, {
          'en': 'Guatemala',
          'cn': '瓜地马拉',
          'code': 'GT',
          'zone': '502',
        }, {
          'en': 'Guinea',
          'cn': '几内亚',
          'code': 'GN',
          'zone': '224',
        }, {
          'en': 'Guinea-Bissau',
          'cn': '几内亚比绍共和国',
          'code': 'GW',
          'zone': '245',
        }, {
          'en': 'Guyana',
          'cn': '圭亚那',
          'code': 'GY',
          'zone': '592',
        }, {
          'en': 'Haiti',
          'cn': '海地',
          'code': 'HT',
          'zone': '509',
        }, {
          'en': 'Honduras',
          'cn': '洪都拉斯',
          'code': 'HN',
          'zone': '504',
        }, {
          'en': 'Hong Kong',
          'cn': '中国香港',
          'code': 'HK',
          'zone': '852',
        }, {
          'en': 'Hungary',
          'cn': '匈牙利',
          'code': 'HU',
          'zone': '36',
        }, {
          'en': 'Iceland',
          'cn': '冰岛',
          'code': 'IS',
          'zone': '354',
        }, {
          'en': 'India',
          'cn': '印度',
          'code': 'IN',
          'zone': '91',
        }, {
          'en': 'Indonesia',
          'cn': '印度尼西亚',
          'code': 'ID',
          'zone': '62',
        }, {
          'en': 'Iran',
          'cn': '伊朗',
          'code': 'IR',
          'zone': '98',
        }, {
          'en': 'Iraq',
          'cn': '伊拉克',
          'code': 'IQ',
          'zone': '964',
        }, {
          'en': 'Ireland',
          'cn': '爱尔兰',
          'code': 'IE',
          'zone': '353',
        }, {
          'en': 'Israel',
          'cn': '以色列',
          'code': 'IL',
          'zone': '972',
        }, {
          'en': 'Italy',
          'cn': '意大利',
          'code': 'IT',
          'zone': '39',
        }, {
          'en': 'Ivory Coast',
          'cn': '象牙海岸',
          'code': 'CI',
          'zone': '225',
        }, {
          'en': 'Jamaica',
          'cn': '牙买加',
          'code': 'JM',
          'zone': '1876',
        }, {
          'en': 'Japan',
          'cn': '日本',
          'code': 'JP',
          'zone': '81',
        }, {
          'en': 'Jordan',
          'cn': '约旦',
          'code': 'JO',
          'zone': '962',
        }, {
          'en': 'Kazakhstan',
          'cn': '哈萨克斯坦',
          'code': 'KZ',
          'zone': '7',
        }, {
          'en': 'Kenya',
          'cn': '肯尼亚',
          'code': 'KE',
          'zone': '254',
        }, {
          'en': 'Kiribati',
          'cn': '基里巴斯',
          'code': 'KI',
          'zone': '686',
        }, {
          'en': 'Kuwait',
          'cn': '科威特',
          'code': 'KW',
          'zone': '965',
        }, {
          'en': 'Kyrgyzstan',
          'cn': '吉尔吉斯斯坦',
          'code': 'KG',
          'zone': '996',
        }, {
          'en': 'Laos',
          'cn': '老挝',
          'code': 'LA',
          'zone': '856',
        }, {
          'en': 'Latvia',
          'cn': '拉脱维亚',
          'code': 'LV',
          'zone': '371',
        }, {
          'en': 'Lebanon',
          'cn': '黎巴嫩',
          'code': 'LB',
          'zone': '961',
        }, {
          'en': 'Lesotho',
          'cn': '莱索托',
          'code': 'LS',
          'zone': '266',
        }, {
          'en': 'Liberia',
          'cn': '利比里亚',
          'code': 'LR',
          'zone': '231',
        }, {
          'en': 'Libya',
          'cn': '利比亚',
          'code': 'LY',
          'zone': '218',
        }, {
          'en': 'Liechtenstein',
          'cn': '列支敦士登',
          'code': 'LI',
          'zone': '423',
        }, {
          'en': 'Lithuania',
          'cn': '立陶宛',
          'code': 'LT',
          'zone': '370',
        }, {
          'en': 'Luxembourg',
          'cn': '卢森堡',
          'code': 'LU',
          'zone': '352',
        }, {
          'en': 'Macau',
          'cn': '中国澳门',
          'code': 'MO',
          'zone': '853',
        }, {
          'en': 'Macedonia',
          'cn': '马其顿',
          'code': 'MK',
          'zone': '389',
        }, {
          'en': 'Madagascar',
          'cn': '马达加斯加',
          'code': 'MG',
          'zone': '261',
        }, {
          'en': 'Malawi',
          'cn': '马拉维',
          'code': 'MW',
          'zone': '265',
        }, {
          'en': 'Malaysia',
          'cn': '马来西亚',
          'code': 'MY',
          'zone': '60',
        }, {
          'en': 'Maldives',
          'cn': '马尔代夫',
          'code': 'MV',
          'zone': '960',
        }, {
          'en': 'Mali',
          'cn': '马里',
          'code': 'ML',
          'zone': '223',
        }, {
          'en': 'Malta',
          'cn': '马耳他',
          'code': 'MT',
          'zone': '356',
        }, {
          'en': 'Martinique',
          'cn': '马提尼克',
          'code': 'MQ',
          'zone': '596',
        }, {
          'en': 'Mauritania',
          'cn': '毛里塔尼亚',
          'code': 'MR',
          'zone': '222',
        }, {
          'en': 'Mauritius',
          'cn': '毛里求斯',
          'code': 'MU',
          'zone': '230',
        }, {
          'en': 'Mayotte',
          'cn': '马约特',
          'code': 'YT',
          'zone': '269',
        }, {
          'en': 'Mexico',
          'cn': '墨西哥',
          'code': 'MX',
          'zone': '52',
        }, {
          'en': 'Moldova',
          'cn': '摩尔多瓦',
          'code': 'MD',
          'zone': '373',
        }, {
          'en': 'Monaco',
          'cn': '摩纳哥',
          'code': 'MC',
          'zone': '377',
        }, {
          'en': 'Mongolia',
          'cn': '蒙古',
          'code': 'MN',
          'zone': '976',
        }, {
          'en': 'Montenegro',
          'cn': '黑山',
          'code': 'ME',
          'zone': '382',
        }, {
          'en': 'Montserrat',
          'cn': '蒙特塞拉特岛',
          'code': 'MS',
          'zone': '1664',
        }, {
          'en': 'Morocco',
          'cn': '摩洛哥',
          'code': 'MA',
          'zone': '212',
        }, {
          'en': 'Mozambique',
          'cn': '莫桑比克',
          'code': 'MZ',
          'zone': '258',
        }, {
          'en': 'Myanmar',
          'cn': '缅甸',
          'code': 'MM',
          'zone': '95',
        }, {
          'en': 'Namibia',
          'cn': '纳米比亚',
          'code': 'NA',
          'zone': '264',
        }, {
          'en': 'Nepal',
          'cn': '尼泊尔',
          'code': 'NP',
          'zone': '977',
        }, {
          'en': 'Netherlands',
          'cn': '荷兰',
          'code': 'NL',
          'zone': '31',
        }, {
          'en': 'New Caledonia',
          'cn': '新喀里多尼亚',
          'code': 'NC',
          'zone': '687',
        }, {
          'en': 'New Zealand',
          'cn': '新西兰',
          'code': 'NZ',
          'zone': '64',
        }, {
          'en': 'Nicaragua',
          'cn': '尼加拉瓜',
          'code': 'NI',
          'zone': '505',
        }, {
          'en': 'Niger',
          'cn': '尼日尔',
          'code': 'NE',
          'zone': '227',
        }, {
          'en': 'Nigeria',
          'cn': '尼日利亚',
          'code': 'NG',
          'zone': '234',
        }, {
          'en': 'Norway',
          'cn': '挪威',
          'code': 'NO',
          'zone': '47',
        }, {
          'en': 'Oman',
          'cn': '阿曼',
          'code': 'OM',
          'zone': '968',
        }, {
          'en': 'Pakistan',
          'cn': '巴基斯坦',
          'code': 'PK',
          'zone': '92',
        }, {
          'en': 'Palau',
          'cn': '帕劳',
          'code': 'PW',
          'zone': '680',
        }, {
          'en': 'Palestine',
          'cn': '巴勒斯坦',
          'code': 'BL',
          'zone': '970',
        }, {
          'en': 'Panama',
          'cn': '巴拿马',
          'code': 'PA',
          'zone': '507',
        }, {
          'en': 'Papua New Guinea',
          'cn': '巴布亚新几内亚',
          'code': 'PG',
          'zone': '675',
        }, {
          'en': 'Paraguay',
          'cn': '巴拉圭',
          'code': 'PY',
          'zone': '595',
        }, {
          'en': 'Peru',
          'cn': '秘鲁',
          'code': 'PE',
          'zone': '51',
        }, {
          'en': 'Philippines',
          'cn': '菲律宾',
          'code': 'PH',
          'zone': '63',
        }, {
          'en': 'Poland',
          'cn': '波兰',
          'code': 'PL',
          'zone': '48',
        }, {
          'en': 'Portugal',
          'cn': '葡萄牙',
          'code': 'PT',
          'zone': '351',
        }, {
          'en': 'Puerto Rico',
          'cn': '波多黎各',
          'code': 'PR',
          'zone': '1787',
        }, {
          'en': 'Qatar',
          'cn': '卡塔尔',
          'code': 'QA',
          'zone': '974',
        }, {
          'en': 'Republic Of The Congo',
          'cn': '刚果共和国',
          'code': 'CG',
          'zone': '242',
        }, {
          'en': 'Réunion Island',
          'cn': '留尼汪',
          'code': 'RE',
          'zone': '262',
        }, {
          'en': 'Romania',
          'cn': '罗马尼亚',
          'code': 'RO',
          'zone': '40',
        }, {
          'en': 'Russia',
          'cn': '俄罗斯',
          'code': 'RU',
          'zone': '7',
        }, {
          'en': 'Rwanda',
          'cn': '卢旺达',
          'code': 'RW',
          'zone': '250',
        }, {
          'en': 'Saint Kitts and Nevis',
          'cn': '圣基茨和尼维斯',
          'code': 'KN',
          'zone': '1869',
        }, {
          'en': 'Saint Lucia',
          'cn': '圣露西亚',
          'code': 'LC',
          'zone': '1758',
        }, {
          'en': 'Saint Pierre and Miquelon',
          'cn': '圣彼埃尔和密克隆岛',
          'code': 'PM',
          'zone': '508',
        }, {
          'en': 'Saint Vincent and The Grenadines',
          'cn': '圣文森特和格林纳丁斯',
          'code': 'VC',
          'zone': '1784',
        }, {
          'en': 'Samoa',
          'cn': '萨摩亚',
          'code': 'WS',
          'zone': '685',
        }, {
          'en': 'San Marino',
          'cn': '圣马力诺',
          'code': 'SM',
          'zone': '378',
        }, {
          'en': 'Sao Tome and Principe',
          'cn': '圣多美和普林西比',
          'code': 'ST',
          'zone': '239',
        }, {
          'en': 'Saudi Arabia',
          'cn': '沙特阿拉伯',
          'code': 'SA',
          'zone': '966',
        }, {
          'en': 'Senegal',
          'cn': '塞内加尔',
          'code': 'SN',
          'zone': '221',
        }, {
          'en': 'Serbia',
          'cn': '塞尔维亚',
          'code': 'RS',
          'zone': '381',
        }, {
          'en': 'Seychelles',
          'cn': '塞舌尔',
          'code': 'SC',
          'zone': '248',
        }, {
          'en': 'Sierra Leone',
          'cn': '塞拉利昂',
          'code': 'SL',
          'zone': '232',
        }, {
          'en': 'Singapore',
          'cn': '新加坡',
          'code': 'SG',
          'zone': '65',
        }, {
          'en': 'Saint Maarten (Dutch Part)',
          'cn': '圣马丁岛（荷兰部分）',
          'code': 'SX',
          'zone': '1721',
        }, {
          'en': 'Slovakia',
          'cn': '斯洛伐克',
          'code': 'SK',
          'zone': '421',
        }, {
          'en': 'Slovenia',
          'cn': '斯洛文尼亚',
          'code': 'SI',
          'zone': '386',
        }, {
          'en': 'Solomon Islands',
          'cn': '所罗门群岛',
          'code': 'SB',
          'zone': '677',
        }, {
          'en': 'Somalia',
          'cn': '索马里',
          'code': 'SO',
          'zone': '252',
        }, {
          'en': 'South Africa',
          'cn': '南非',
          'code': 'ZA',
          'zone': '27',
        }, {
          'en': 'South Korea',
          'cn': '韩国',
          'code': 'KR',
          'zone': '82',
        }, {
          'en': 'Spain',
          'cn': '西班牙',
          'code': 'ES',
          'zone': '34',
        }, {
          'en': 'Sri Lanka',
          'cn': '斯里兰卡',
          'code': 'LK',
          'zone': '94',
        }, {
          'en': 'Sudan',
          'cn': '苏丹',
          'code': 'SD',
          'zone': '249',
        }, {
          'en': 'Suriname',
          'cn': '苏里南',
          'code': 'SR',
          'zone': '597',
        }, {
          'en': 'Swaziland',
          'cn': '斯威士兰',
          'code': 'SZ',
          'zone': '268',
        }, {
          'en': 'Sweden',
          'cn': '瑞典',
          'code': 'SE',
          'zone': '46',
        }, {
          'en': 'Switzerland',
          'cn': '瑞士',
          'code': 'CH',
          'zone': '41',
        }, {
          'en': 'Syria',
          'cn': '叙利亚',
          'code': 'SY',
          'zone': '963',
        }, {
          'en': 'Taiwan',
          'cn': '中国台湾',
          'code': 'TW',
          'zone': '886',
        }, {
          'en': 'Tajikistan',
          'cn': '塔吉克斯坦',
          'code': 'TJ',
          'zone': '992',
        }, {
          'en': 'Tanzania',
          'cn': '坦桑尼亚',
          'code': 'TZ',
          'zone': '255',
        }, {
          'en': 'Thailand',
          'cn': '泰国',
          'code': 'TH',
          'zone': '66',
        }, {
          'en': 'Timor-Leste',
          'cn': '东帝汶',
          'code': 'TL',
          'zone': '670',
        }, {
          'en': 'Togo',
          'cn': '多哥',
          'code': 'TG',
          'zone': '228',
        }, {
          'en': 'Tonga',
          'cn': '汤加',
          'code': 'TO',
          'zone': '676',
        }, {
          'en': 'Trinidad and Tobago',
          'cn': '特立尼达和多巴哥',
          'code': 'TT',
          'zone': '1868',
        }, {
          'en': 'Tunisia',
          'cn': '突尼斯',
          'code': 'TN',
          'zone': '216',
        }, {
          'en': 'Turkey',
          'cn': '土耳其',
          'code': 'TR',
          'zone': '90',
        }, {
          'en': 'Turkmenistan',
          'cn': '土库曼斯坦',
          'code': 'TM',
          'zone': '993',
        }, {
          'en': 'Turks and Caicos Islands',
          'cn': '特克斯和凯科斯群岛',
          'code': 'TC',
          'zone': '1649',
        }, {
          'en': 'Uganda',
          'cn': '乌干达',
          'code': 'UG',
          'zone': '256',
        }, {
          'en': 'Ukraine',
          'cn': '乌克兰',
          'code': 'UA',
          'zone': '380',
        }, {
          'en': 'United Kingdom',
          'cn': '英国',
          'code': 'GB',
          'zone': '44',
        }, {
          'en': 'United States',
          'cn': '美国',
          'code': 'US',
          'zone': '1',
        }, {
          'en': 'Uruguay',
          'cn': '乌拉圭',
          'code': 'UY',
          'zone': '598',
        }, {
          'en': 'Uzbekistan',
          'cn': '乌兹别克斯坦',
          'code': 'UZ',
          'zone': '998',
        }, {
          'en': 'Vanuatu',
          'cn': '瓦努阿图',
          'code': 'VU',
          'zone': '678',
        }, {
          'en': 'Venezuela',
          'cn': '委内瑞拉',
          'code': 'VE',
          'zone': '58',
        }, {
          'en': 'Vietnam',
          'cn': '越南',
          'code': 'VN',
          'zone': '84',
        }, {
          'en': 'Virgin Islands, British',
          'cn': '英属处女群岛',
          'code': 'VG',
          'zone': '1340',
        }, {
          'en': 'Virgin Islands, US',
          'cn': '美属维尔京群岛',
          'code': 'VI',
          'zone': '1284',
        }, {
          'en': 'Yemen',
          'cn': '也门',
          'code': 'YE',
          'zone': '967',
        }, {
          'en': 'Zambia',
          'cn': '赞比亚',
          'code': 'ZM',
          'zone': '260',
        }, {
          'en': 'Zimbabwe',
          'cn': '津巴布韦',
          'code': 'ZW',
          'zone': '263',
        }],
      phonedisabled: true,
      emaildisabled: true,
      addDialogVisible: false,
      countdown: 0,
      emailCountdown: 0,
      timer: null,
      form: {
        type: 'phone',
        phoneNumber: '',
        code: '',
        email: '',
        emailCode: ''
      },
      rules: {
        phoneNumber: [{
          required: true,
          message: this.$t('Pleaseenteryourphonenumber'),//  "请输入手机号",
          trigger: "blur",
        }],
        code: [{
          required: true,
          message: this.$t('Pleaseentertheverificationcode'),// "请输入验证码",
          trigger: "blur",
        }],
        email: [{
          required: true,
          message: this.$t('Pleaseenteremail'),// "请输入邮箱",
          trigger: "blur",
        }, {
          trigger: "blur",
          validator: validatorEmail,
        }],
        emailCode: [{
          required: true,
          message: this.$t('placeholderCode'),//  "请输入验证码",
          trigger: "blur",
        }]
      },
    }
  },
  methods: {
    open(val, lang) {
      this.addDialogVisible = true
      this.$i18n.locale = lang;
      if (val) { // 编辑
        this.form = val;
        console.log("this val", val);
      } else {
        this.form = {}

      }
    },
    dialogCloseFun() {
      this.resetForm('ruleForm')
    },
    resetForm() {
      this.form = { type: 'phone' }
      this.addDialogVisible = false
    },
    /**
     * @description 提交表单
     * **/
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.type == 'phone') {
            this.saveConfigFunc()
          } else if (this.form.type == 'email') {
            this.saveEmailConfigFunc()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * @description 手机提交表单
     * **/
    async saveConfigFunc() {
      let params = {
        ...this.form
      }
      params.phoneNumber = this.zonevalue + this.form.phoneNumber
      const { data: { statusCode, errors, data } } = await Api_login.checkCode(params)
      if (statusCode === 200 && data) {
        this.addDialogVisible = false
        this.checkTime()
        // this.updatePhone()
      } else {
        this.$showMessage("失败", '验证码输入错误');
      }
    },

    /**
     * @description 邮箱提交表单
     * **/
    async saveEmailConfigFunc() {
      let params = {
        emailAddress: this.form.email,
        code: this.form.emailCode
      }
      const { data: { statusCode, errors, data } } = await Api_login.checkEmailCode(params)
      if (statusCode === 200 && data) {
        this.addDialogVisible = false
        this.checkTime()
        // this.updatePhone()
      } else {
        this.$showMessage("失败", '验证码输入错误');
      }
    },
    /**
     * @description 设置用户登陆时间和二次验证时间
     * **/
    async checkTime() {
      const { data: { statusCode, data } } = await Api_login.checkTime(getStore({ name: "userId" }))
      if (statusCode == 200 && data) {
        this.$message({
          type: "success",
          message: "验证成功!",
        });
        this.$emit('check')
      } else {
        this.$showMessage("失败", '手机号验证失败！');
      }
    },
    //更新手机号
    async updatePhone() {
      let params = {
        "userId": getStore({ name: "userId" }),
        "phone": this.form.phoneNumber
      }
      const { data: { statusCode, data } } = await Api_login.updatePhone(params)
      if (statusCode == 200 && data) {
        this.$message({
          type: "success",
          message: "绑定成功!",
        });
      } else {
        this.$showMessage("失败", '手机号绑定失败！');
      }
    },
    /**
     * @description 发送手机验证码
     * **/
    async startCountdown() {
      if (this.countdown > 0 || this.form.phoneNumber.length === 0) {
        return;
      }
      //发送验证码
      await Api_login.sendMsg(this.zonevalue + this.form.phoneNumber)
      this.countdown = 60;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          // 倒计时结束时清除定时器
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    /**
     * @description 发送邮箱验证码
     * **/
    async startEmailCountdown() {
      if (this.emailCountdown > 0 || !isEmail(this.form.email)) {
        return;
      }
      //发送验证码
      await Api_login.sendEmail(this.form.email)
      this.emailCountdown = 60;
      this.timer = setInterval(() => {
        if (this.emailCountdown > 0) {
          this.emailCountdown--;
        }
        else {
          // 倒计时结束时清除定时器
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    /**
     *@description 手机号输入框可编辑
     * **/
    editPhoneNumber() {
      this.phonedisabled = false;

    },

    /**
     * @description 邮箱输入框可编辑
     * **/
    editEmailNumber() {
      this.emaildisabled = false;

    },

    /**
     * @description 切换单选框值变化事件
     * **/
    onRadioChange() {
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate();
      })
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>
<style lang="scss" >
.el-radio__input.is-checked + .el-radio__label {
  color: #e9e9e9;
}

.el-input.is-disabled .el-input__inner {
  background-color: #092963;
  border-color: #365f7d;
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>